import { validateEnumTranslations } from '../../safety_checks';

/** Dimension d'analyse de `GET /app/stats/business/breakdown`. */
export enum StatsBreakdownDimension {
  PRESTATION = 'PRESTATION',
  TEAM_MEMBER = 'TEAM_MEMBER',
  PRO_PLACE = 'PRO_PLACE',
}

export const STATS_BREAKDOWN_DIMENSION_TRANSLATE_KEY = 'STATS_BREAKDOWN_DIMENSION_';

export const StatsBreakdownDimensionTranslation = {
  'fr-FR': {
    [`${STATS_BREAKDOWN_DIMENSION_TRANSLATE_KEY}${StatsBreakdownDimension.PRESTATION}`]: 'Par prestation',
    [`${STATS_BREAKDOWN_DIMENSION_TRANSLATE_KEY}${StatsBreakdownDimension.TEAM_MEMBER}`]: 'Par membre d’équipe',
    [`${STATS_BREAKDOWN_DIMENSION_TRANSLATE_KEY}${StatsBreakdownDimension.PRO_PLACE}`]: 'Par lieu',
  },
};

validateEnumTranslations(
  StatsBreakdownDimension,
  StatsBreakdownDimensionTranslation,
  STATS_BREAKDOWN_DIMENSION_TRANSLATE_KEY,
  true,
);

/** Granularité d'une série temporelle, choisie par le serveur selon la largeur de la fenêtre. */
export enum StatsGranularity {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

/**
 * Constat chiffré qui mérite une action (« constat → remède »). Calculé côté serveur à partir
 * des agrégats et de la formule du pro ; le front et Pulse affichent le même libellé.
 */
export enum StatsNudgeCode {
  NO_SHOW_RATE = 'NO_SHOW_RATE',
  INACTIVE_CUSTOMERS = 'INACTIVE_CUSTOMERS',
  REVIEWS_WITHOUT_REPLY = 'REVIEWS_WITHOUT_REPLY',
  HIGH_OCCUPANCY = 'HIGH_OCCUPANCY',
  GOOGLE_NOT_CONNECTED = 'GOOGLE_NOT_CONNECTED',
}

export const STATS_NUDGE_TRANSLATE_KEY = 'STATS_NUDGE_';

export const StatsNudgeCodeTranslation = {
  'fr-FR': {
    [`${STATS_NUDGE_TRANSLATE_KEY}${StatsNudgeCode.NO_SHOW_RATE}`]: 'Vos clients absents vous coûtent des créneaux',
    [`${STATS_NUDGE_TRANSLATE_KEY}${StatsNudgeCode.INACTIVE_CUSTOMERS}`]:
      'Des clients ne sont pas revenus depuis plus de 3 mois',
    [`${STATS_NUDGE_TRANSLATE_KEY}${StatsNudgeCode.REVIEWS_WITHOUT_REPLY}`]: 'Des avis Google attendent une réponse',
    [`${STATS_NUDGE_TRANSLATE_KEY}${StatsNudgeCode.HIGH_OCCUPANCY}`]: 'Votre agenda est presque plein',
    [`${STATS_NUDGE_TRANSLATE_KEY}${StatsNudgeCode.GOOGLE_NOT_CONNECTED}`]: 'Aucune réservation ne vient de Google',
  },
};

validateEnumTranslations(StatsNudgeCode, StatsNudgeCodeTranslation, STATS_NUDGE_TRANSLATE_KEY, true);

/**
 * Remède proposé par un nudge : un bénéfice de la formule supérieure (formulé en résultat pour le
 * pro, jamais en nom de fonctionnalité) ou une action déjà incluse dans sa formule.
 */
export enum StatsNudgeRemedy {
  DEPOSIT_AT_BOOKING = 'DEPOSIT_AT_BOOKING',
  CB_IMPRINT = 'CB_IMPRINT',
  CB_IMPRINT_SETTINGS = 'CB_IMPRINT_SETTINGS',
  CAMPAIGNS = 'CAMPAIGNS',
  RELAUNCH_CUSTOMERS = 'RELAUNCH_CUSTOMERS',
  AI_REVIEW_REPLY = 'AI_REVIEW_REPLY',
  REPLY_WITH_PULSE = 'REPLY_WITH_PULSE',
  ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER',
  CONNECT_GOOGLE = 'CONNECT_GOOGLE',
}

export const STATS_NUDGE_REMEDY_TRANSLATE_KEY = 'STATS_NUDGE_REMEDY_';

export const StatsNudgeRemedyTranslation = {
  'fr-FR': {
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.DEPOSIT_AT_BOOKING}`]:
      'Demandez un acompte à la réservation : les absences chutent quand le client a déjà réglé une partie.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.CB_IMPRINT}`]:
      'Une empreinte bancaire couvre les absences : vous prélevez des frais quand le client ne vient pas.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.CB_IMPRINT_SETTINGS}`]:
      'Activez l’empreinte bancaire sur vos prestations pour couvrir les absences.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.CAMPAIGNS}`]:
      'Faites-les revenir par email ou SMS avec une campagne de relance.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.RELAUNCH_CUSTOMERS}`]:
      'Relancez-les avec une campagne pré-remplie sur ces clients.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.AI_REVIEW_REPLY}`]:
      'Pulse rédige vos réponses aux avis Google en quelques secondes.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.REPLY_WITH_PULSE}`]:
      'Répondez avec Pulse : il vous propose une réponse pour chaque avis.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.ADD_TEAM_MEMBER}`]:
      'Ajoutez un membre d’équipe pour accueillir plus de clients.',
    [`${STATS_NUDGE_REMEDY_TRANSLATE_KEY}${StatsNudgeRemedy.CONNECT_GOOGLE}`]:
      'Connectez votre fiche Google pour recevoir des réservations depuis Google.',
  },
};

validateEnumTranslations(StatsNudgeRemedy, StatsNudgeRemedyTranslation, STATS_NUDGE_REMEDY_TRANSLATE_KEY, true);
